const theme = {
  buttons: {
    primary: {
      bg: '#24cca7',
      color: '#ffffff',
      mb: '20px',
      borderRadius: '20px',
    },
    secondary: {
      bg: 'transparent',
      border: '1px solid #4A56E2',
      color: '#4A56E2',
    },
  },
  fonts: {
    heading: 'Poppins, sans-serif',
    placeholder: 'Circe, sans-serif',
    formField: 'Circe,sans-serif',
    textField: 'Circe, sans-serif',
  },
  fontSizes: ['16px', '18px', '20px'],

  fontWeights: {
    normal: 400,
    bold: 700,
  },
  lineHeights: {
    heading: 1.5,
    formField: 1.5,
  },
  color: {
    primary: '#24cca7',
    muted: '#E0E0E0',
    expense: ' #FF6596',
    calendarIcon: '#4a56e2',
    overlayBg: 'rgba(0, 0, 0, 0.25)',
    modalWindowBg: '#fff',
    switcherBgUncheked: '#fff',
  },
  radii: {
    broderSwitcher: '50%',
    borderBottom: '1px solid #E0E0E0',
    selectList: '30px,',
    modalWindow: '20px',
    switcherBg: '30px',
  },
  borders: {
    borderNone: 'none',
  },

  borderStyles: {
    underline: '1px solid #E0E0E0',
    selectListFocused: '1px solid #4a56e2;',
  },
  borderWidths: {
    selectListBorderColor: '#4a56e2',
  },
  shadows: {
    switcherShadow: '0px 6px 15px rgba(255, 101, 150, 0.5)',
  },
};

export default theme;
